// extracted by mini-css-extract-plugin
module.exports = {"question-options":"style_question-options__QcXan"};